import React from 'react';
import Colors from '../utilities/Colors';
// Import the functions directly from the store
import { HistogramStatic } from './HistogramStatic';
import { HistogramDynamic } from './HistogramDynamic';

interface DataItem {
    id: string;
    value: any; // Consider specifying a more detailed type here
}

export interface HistogramProps {
  dataArray: DataItem[];
  histMax: number;
  histNA: number;
  histLength: number; 
  chartId: string;
  height: string;
  width: string;
  paddingLeft: string;
  paddingRight: string;
  tooltips: boolean;
  colorClass: string;
  data: any;
  indicator: any;
  options?: any;
  nycAvg?: number;
  boroByName?: any;
  auxOptions?: any;
  useCase: string;
}

export const Histogram: React.FC<HistogramProps> = ({ 
    dataArray, histMax, histNA, histLength, chartId, height, width, paddingLeft, paddingRight, tooltips, colorClass, indicator, data, options, nycAvg, boroByName, auxOptions, useCase
}) => {
    //console.log("D100724 dataArray", dataArray);
    //console.log("K092924 histMax", histMax);
    //console.log("K092924 histNA", histNA);
    //console.log("K092924 histLength", histLength);
    //console.log("D100724 chartId", chartId);
    //console.log("C041925 data.meta[DESCRIPTOR][indicator]", data.meta["DESCRIPTOR"][indicator]);
    //console.log("CCCC041925 indicator", indicator);
    //console.log("C041925 data.meta[DESCRIPTOR]", data.meta["DESCRIPTOR"]);
    return (
        <>            
            <HistogramDynamic
                key={`${indicator}_${useCase}_hd`}
                dataArray={dataArray}
                histMax={histMax}
                histNA={histNA} 
                histLength={histLength} 
                chartId={chartId}
                height={height}
                width={width}
                paddingLeft={paddingLeft}
                paddingRight={paddingRight}
                tooltips={tooltips}
                DESCRIPTOR={data.meta["DESCRIPTOR"][indicator]}
                nycAvg={nycAvg}
                boroByName={boroByName}
                useCase={useCase}
                data={data}
            />
            <HistogramStatic 
                dataArray={dataArray}
                histMax={histMax}
                histNA={histNA} 
                histLength={histLength} 
                chartId={chartId}
                height={height}
                width={width}
                paddingLeft={paddingLeft}
                paddingRight={paddingRight}
                colorClass={colorClass}
                DESCRIPTOR={data.meta["DESCRIPTOR"][indicator]}
                options={options ? options : auxOptions}
                nycAvg={nycAvg}
            />
        </>
    );
};
